// Third party
import moment from 'moment';

// Utils
import { truncateString } from './objects';
import { DISCLAIMER_KEYS } from './disclaimers/constants';
import { formatMessage, formatLocalizedString } from './i18n';
import ShortHistoryDisclaimerHolding from '@/types/short-history-disclaimer-holding';
import ComparisonItem from '@/types/comparison-item';
import RiskPeriods from '@/types/risk-periods';
import ComparisonHolding from '@/types/comparison-holding';

export const CORRELATION_MATRIX_COLOURS = ['#c01b74', '#ece9f8', '#0a8adb'];

/**
 * Returns the correlation disclaimer
 * @param {ComparisonItem} item current item
 * @param {RiskPeriods} riskPeriod selected risk period
 * @param {boolean} shortHistory if false, will return null
 * @returns disclaimer or undefined
 */
export const getCorrelationDisclaimer = (item: ComparisonItem, riskPeriod: RiskPeriods, shortHistory?: boolean) => {
  const disclaimer = item.disclaimers && item.disclaimers[DISCLAIMER_KEYS.SHORT_HOLDINGS];

  if (!shortHistory || !disclaimer || !disclaimer.data || !disclaimer.data.fields) {
    return null;
  }

  const field = disclaimer.data.fields.find((f: any) => f.field.includes(riskPeriod));

  if (!field) {
    return null;
  }

  return {
    title: formatMessage('Comparison.Table.LongHistoryTooltip.Title'),
    message: formatMessage('Comparison.Table.LongHistoryTooltip.Message'),
    list: field.holdings.map((h: ShortHistoryDisclaimerHolding) =>
      formatMessage('Comparison.Table.LongHistoryTooltip.PriorTo', {
        symbol: h.symbol || h.name || '',
        date: moment(h.date).format(formatMessage('Common.DateFormats.Short')),
      }),
    ),
  };
};

/**
 * Returns text to be displayed in correlation labels
 * @param {ComparisonHolding} holding current holding
 * @returns the string to be displayed
 */
export const getCorrelationLabelDisplayedText = (holding: ComparisonHolding) =>
  // Length cutoff to reprensent approx. symbols length
  holding.symbol || truncateString(formatLocalizedString(holding.name), 6);
